import React, { useEffect, useState, createContext, useContext } from 'react';
export type Language = 'en' | 'sl';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('msg-language');
    return saved === 'en' || saved === 'sl' ? saved : 'en';
  });
  useEffect(() => {
    localStorage.setItem('msg-language', language);
    document.documentElement.lang = language;
  }, [language]);
  return <LanguageContext.Provider value={{
    language,
    setLanguage
  }} data-id="element-404" data-mp="1b7q7b8ya4dbd">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}